import React, { createContext } from "react";
const initialState = {
  user: null,
  company: null,
};
const SignUpContext = createContext({
  ...initialState,
  setUser: (user) => {},
  setCompany: (company) => {},
});
export const SignUpProvider = ({ children }) => {
  const [userData, setUserData] = React.useState(null);
  const [companyData, setCompanyData] = React.useState(null);
  const setUser = (user) => {
    setUserData(user);
  };
  const setCompany = (company) => {
    setCompanyData(company);
  };
  return (
    <SignUpContext.Provider
      value={{
        user: userData,
        company: companyData,
        setUser,
        setCompany,
      }}
    >
      {children}
    </SignUpContext.Provider>
  );
};

export default SignUpContext;
